<template>
  <div class="header-block">
    <div class="gabarit">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/styles/colors.scss';
.header-block {
  background-color: colors.$main-color;
  display: flex;
  align-items: center;
  .gabarit {
    height: 4.5em;
    display: flex;
    flex-direction: row;
  }
  .entries-container {
    display: flex;
    flex: 1;
    .entry {
      display: flex;
      align-items: center;
      & + .entry {
        &:before {
          content: '';
          display: block;
          width: 1px;
          height: 2em;
          background-color: colors.$white-color;
          margin: 0 1em;
        }
      }
    }
    i {
      font-size: 2.25em;
    }
    .caption,
    .details {
      font-size: 2em;
    }
    .details {
      opacity: 0.5;
    }
  }
  .baseline {
    display: flex;
    align-items: center;
    .caption {
      font-size: 1.75em;
      margin-right: 0.25em;
    }
    .data-value {
      font-size: 3.125em;
      font-weight: 300;
      small {
        font-size: 0.64em;
      }
    }
  }
}
</style>
